import { boolean, literal, object } from "zod/v4";

export const disconnectIDFShippingIntegration = {
  name: "disconnectIDFShippingIntegration" as const,
  input: literal(null),
  output: object({ success: boolean() }),
};
